import React from 'react'

const AssetListComponent = () => {
    return (
        <div>AssetListComponent</div>
    )
}

export default AssetListComponent